<app-overlay
  [visible]="!!(!closed || openedState)"
  [container]="container"
  [overlayMask]="!!overlayMask"
  [animate]="false"
  [deferRendering]="true"
  (onContentReady)="onContentReadyInternal()"
>
  <ng-template overlayContent>
    <div
      #bottomSheetContainerEl
      class="bottom-sheet-container {{ minimized ? 'minimized-mode' : '' }}"
      [ngStyle]="{ height, maxHeight, minHeight }"
      [@handleOpened]="!!openedState"
      (@handleOpened.start)="onTriggerEventStart($event)"
      (@handleOpened.done)="onTriggerEventDone($event)"
    >
      <div *ngIf="!!showHeader" class="bottom-sheet-header">
        <app-toolbar
          class="bottom-sheet-toolbar"
          [ngClass]="{ 'has-bottom-divider': !!showHeaderDivider }"
        >
          <div appToolbarItemBefore *ngIf="!!sheetTitle" class="title">
            {{ sheetTitle }}
          </div>

          <app-button
            *ngIf="!!minimizeBtnEnabled"
            appToolbarItemAfter
            class="minimize-btn"
            buttonType="normal"
            styleType="text"
            shapeType="circle"
            sizeType="small"
            icon="assets/icons/{{
              !minimized ? 'minus' : 'up-right-and-down-left-from-center'
            }}.svg"
            title="{{ minimized ? 'Maximizar' : 'Minimizar' }}"
            (click)="onBtnMinimizeToggleClick($event)"
          ></app-button>

          <app-button
            appToolbarItemAfter
            class="close-btn"
            buttonType="normal"
            styleType="text"
            shapeType="circle"
            icon="assets/icons/xmark.svg"
            title="Fechar"
            (click)="onBtnCloseClick()"
          ></app-button>
        </app-toolbar>
      </div>

      <div class="content">
        <ng-container *ngIf="!contentTpl?.templateRef; else contentTplRef">
          <ng-content></ng-content>
        </ng-container>
      </div>
    </div>
  </ng-template>
</app-overlay>

<ng-template #contentTplRef>
  <ng-template [ngTemplateOutlet]="contentTpl.templateRef"></ng-template>
</ng-template>
